const TELA_ACOES = {
    Incluir:0,
    Consultar:1,
    Alterar:2,
    Apagar:3,
    QrCode:4,
    Geolocalização:5,
    Imprimir:6,
    Finalizar:7,
}
export default TELA_ACOES;
